import type { ReactNode } from "react";

// ── Ajan arayüzü yapı taşları (TailAdmin dili) — İçerik Üretim Ajanı + Brief Keşif
// Ajanı ortak stili. Marka rengi brand-500, light/dark uyumlu, token tipografisi.
export function AgentGroup({ icon, label, children, hint }: { icon?: string; label: string; children: ReactNode; hint?: string }) {
  return (
    <div>
      <div className="mb-2 flex items-center gap-1.5 text-theme-xs font-semibold uppercase tracking-wide text-gray-400">
        {icon} {label}
      </div>
      <div className="flex flex-wrap gap-2">{children}</div>
      {hint && <div className="mt-1.5 text-theme-xs text-gray-400">{hint}</div>}
    </div>
  );
}

export function AgentOption({ active, onClick, label, sub, title, small, check }: {
  active: boolean; onClick: () => void; label: string; sub?: string; title?: string; small?: boolean; check?: boolean;
}) {
  return (
    <button
      onClick={onClick}
      title={title}
      className={`relative rounded-xl border text-left transition ${small ? "px-3 py-1.5" : "px-4 py-2.5"} ${
        active
          ? "border-brand-500 bg-brand-50 text-brand-600 shadow-theme-xs dark:border-brand-500/60 dark:bg-brand-500/10 dark:text-brand-400"
          : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50 dark:border-gray-800 dark:bg-white/[0.03] dark:text-gray-300 dark:hover:bg-white/[0.06]"
      }`}
    >
      {check && active && (
        <span className="absolute -right-1.5 -top-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-brand-500 text-[10px] text-white">✓</span>
      )}
      <div className={`${small ? "text-theme-xs" : "text-theme-sm"} font-medium`}>{label}</div>
      {sub && !small && <div className="mt-0.5 text-theme-xs text-gray-400">{sub}</div>}
    </button>
  );
}
